import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "announcement-reviewer-setup",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "admin-announcements-manager" */ "Administrator/routes/Settings/routes/AnnouncementsManager/routes/ReviewerSetup/components"
      ),
      import(
        /* webpackChunkName: "admin-announcements-manager" */ "Administrator/routes/Settings/routes/AnnouncementsManager/routes/ReviewerSetup/modules/ReviewerSetupModule"
      ),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: importedModule1.NAME,
          reducer,
        });
        return component;
      })
      .catch(err => {
        return err;
      })
  ),
});
